import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useMeta } from "@/lib/site";
import { Overline, Reveal } from "@/components/Reveal";

export default function PolicyPage({ policyKey }) {
  const { data: p } = useQuery({ queryKey: ["policy", policyKey], queryFn: async () => (await api.get(`/policies/${policyKey}`)).data });
  useMeta(p?.title, p?.title ? `${p.title} — Bonheur Eternal customer care.` : undefined);
  if (!p) return <div className="min-h-screen" />;

  return (
    <article className="pt-32 md:pt-44 pb-32 px-5 md:px-8 max-w-3xl mx-auto">
      <Reveal>
        <Link to="/customer-care" data-testid="policy-back-link" className="text-[11px] tracking-[0.25em] uppercase text-[#6E6151] hover:text-[#8F6B3A] transition-colors">
          ← Customer Care
        </Link>
        <Overline className="mt-8">Customer Care</Overline>
        <h1 className="font-display text-4xl md:text-5xl text-[#2B2118] mt-4 tracking-tight leading-tight" data-testid="policy-title">{p.title}</h1>
        {p.updated && <p className="mt-4 text-xs text-[#6E6151]">Last updated — {p.updated}</p>}
      </Reveal>
      {p.note && (
        <Reveal delay={0.1} className="mt-10 border border-[#8F6B3A]/30 bg-[#8F6B3A]/[0.05] p-6">
          <p className="text-sm text-[#8F6B3A] leading-relaxed">{p.note}</p>
        </Reveal>
      )}
      <div className="mt-14 space-y-14">
        {(p.sections || []).map((s, i) => (
          <Reveal key={i} delay={0.05}>
            {s.heading && <h2 className="font-display text-2xl text-[#2B2118] tracking-tight">{s.heading}</h2>}
            {(s.body || "").split("\n\n").map((para, j) => (
              <p key={j} className="mt-5 text-[#5A4C3C] leading-loose whitespace-pre-line">{para}</p>
            ))}
          </Reveal>
        ))}
      </div>
      <Reveal className="mt-20 border-t border-[#2B2118]/[0.06] pt-10">
        <p className="text-sm text-[#6E6151] leading-relaxed">
          Questions about this policy? Reach us on{" "}
          <a href="https://wa.me/923332644998" target="_blank" rel="noopener noreferrer" className="text-[#8F6B3A] hover:underline">WhatsApp</a> or{" "}
          <a href="mailto:hello.bonheureternal@gmail.com" className="text-[#8F6B3A] hover:underline">hello.bonheureternal@gmail.com</a>.
        </p>
      </Reveal>
    </article>
  );
}
